import { Bairro, Logradouro } from "@tivic-team/manager-ts/dist/grl";

export class LogradouroDTO extends Logradouro{
    bairro: Bairro = void(0);
    cdCidade: number = void(0);
    nmCidade: string = void(0);
    cdTipoLogradouro: number = void(0);
    nmTipoLogradouro: string = void(0);
    sgTipoLogradouro: string = void(0);
}